import axios from "axios";
import I18Next from "../Control/Vue/I18Next";
import { AntiSpamCountryLaw } from "../utils/AntiSpamCountryLaw";
import { prompt } from "./../Control/Vue/Notifications/Prompts";

export class ProfileForm {
	private readonly profileForm: JQuery;
	private readonly updateButton: JQuery;
	private readonly form: JQuery;

	private loading = false;

	constructor(containerId: DOMElementIdentifier, _constructionParameters: ConstructionParameters) {
		this.profileForm = jQuery("#" + containerId);

		this.updateButton = this.profileForm.find(".mia-updateButton");
		this.updateButton.on("click", (event) => void this.onUpdateButtonClick(event));

		this.form = jQuery("form");
		this.form.validate().settings.errorPlacement = (error: JQuery, element: JQuery) => {
			element.parents(".form-group").find(".error-container").append(error);
		};

		const emailPreferences = jQuery(".mia-emailPreferences");
		if (emailPreferences) {
			const countryDropDown = this.profileForm.find("#parentCountry");
			countryDropDown.change(AntiSpamCountryLaw.OnCountryDropDownChange.bind(this));
		}
	}

	private async onUpdateButtonClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		if (this.loading || !this.form.valid()) {
			return;
		}

		const firstName = this.profileForm.find("#parentFirstName").val();
		const lastName = this.profileForm.find("#parentLastName").val();
		const country = this.profileForm.find("#parentCountry").val();
		const timeZoneId = this.profileForm.find("#parentTimeZone").val();
		const acceptNewsletters = AntiSpamCountryLaw.GetNewsletterValue();
		const acceptChildReports = AntiSpamCountryLaw.GetChildReportValue();

		const updateURL = this.updateButton.data("url")
			.replace("PLH_fname", firstName)
			.replace("PLH_lname", lastName)
			.replace("PLH_country", country)
			.replace("PLH_tzid", timeZoneId)
			.replace("PLH_acceptNewsletters", acceptNewsletters)
			.replace("PLH_acceptChildReports", acceptChildReports);

		this.loading = true;
		this.updateButton.button("loading");
		try {
			const response = await axios.get(updateURL);
			this.onUpdateSucceeded(response.data);
		}
		finally {
			this.updateButton.button("reset");
			this.loading = false;
		}
	}

	private onUpdateSucceeded(data: any) {
		if (data.success) {
			window.location.reload();
		}
		else {
			if (data.errorMessage) {
				prompt(data.errorMessage, [{ label: I18Next.tr("OkCancel_Ok"), value: undefined }]);
			}
		}
	}
}
